<i18n>
{
	"en": {
		"appSend": "Send to App",
		"orderSent": "Order sent to {driver}",
		"failedToSend": "Failed sending order to {driver}"
	},
	"no": {
		"appSend": "Send til Confirm",
		"orderSent": "Oppdrag sendt til {driver}",
		"failedToSend": "Feilet ved sending av oppdrag til {driver}"
	}
}
</i18n>

<template>
	<div>
		<t-button
			:value="$t('appSend')"
			:disabled="disabled"
			appearance="primary"
			:intent="intent"
			style="margin-left: 15px;"
			type="bp"
			iconBefore="globe"
			@click="onClick"
		/>
		<drivers-form-input-dialog
			:items="drivers"
			:isShown="showDialog"
			icon="person"
			@close="onClose"
			@ok="onOk"
		/>
	</div>
</template>

<script>
import { mapState, mapActions } from './store/sendSubOrderToConfirm.store';
import DriversFormInputDialog from '@/modules/drivers/DriversFormInput/DriversDialog';
export default {
	components: {
		DriversFormInputDialog,
	},
	props: {
		subOrder: Object,
		disabled: Boolean,
	},
	data() {
		return {
			showDialog: false
		};
	},
	computed: {
		...mapState(['drivers']),
		wasSent() {
			return this.subOrder === undefined ? false : this.subOrder.wasSent;
		},
		intent() {
			return this.wasSent ? 'success' : 'default';
		}
	},
	async mounted() {
		await this.getDrivers();
	},
	methods: {
		...mapActions(['sendToConfirm', 'cleanState', 'getDrivers']),
		onClick() {
			this.showDialog = true;
		},
		onClose() {
			this.showDialog = false;
		},
		async onOk(driver) {
			this.showDialog = false;
			try {
				await this.sendToConfirm({ orderId: this.subOrder.id, driver });
				this.$notify({
					type: 'success',
					title: this.$tc('orderSent',2, { driver: driver.name })
				});

			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$tc('failedToSend', 2, { driver: driver.name }),
					duration: -1
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
